import reducers from "@tw/customer-identity-cra/lib/login/redux/reducers";

export default [
  {
    id: "@ci/login",
    reducerMap: reducers,
  },
];
